import type { IResOrderById } from '@/types/fulfill/statusOrders';

export const formatDataFF = (data: IResOrderById['data']) => {
  return {
    additional: {
      cashOnDelivery: data?.payments?.cashOnDelivery && data?.payments?.cashOnDelivery?.amount,
      insured: 0,
      notes: data?.notes,
      orderPrice: data?.price?.totalPrice ? parseInt(data?.price?.totalPrice) : 0,
    },
    size: data?.packageSize,
    createdAt: data?.createdAt,
    deliveryType: data?.deliveryType,
    recipient: {
      firstName: data.destination.nameReceiver,
      lastName: data.destination.lastNameReceiver,
      phone: data.destination.phoneReceiver,
    },
    destination: {
      address: data.destination.addressDestination,
      reference: '',
    },
    origin: {
      address: data?.origin?.addressOrigin || 'No disponible',
      reference: 'No disponible',
      zipCode: data?.origin?.codePostalOrigin || 'No disponible',
      country: data?.origin?.country || 'No disponible',
    },
    sender: {
      firstName: data?.origin?.nameSender || 'Fulfillment',
      lastName: data?.origin?.lastNameSender || '',
      phone: data?.origin?.phoneSender || '+5563631559',
    },
    internalKey: data?.internalKey,
    status: data?.fulfillmentStatus,
    statusNameES: data?.fulfillmentStatus,
    trackingId: data?.tracking[0],
  };
};
